module.exports = __webpack_public_path__ + "static/media/topFaceArrow.3b845402.svg";